import { Injectable, signal } from '@angular/core';
import { LightboxData } from '@klubovna/shared-models';

@Injectable({
  providedIn: 'root',
})
export class LightboxService {
  private _isVisible = signal(false);
  private _imageUrl = signal('');
  private _altText = signal('');
  private _images = signal<string[]>([]);
  private _currentIndex = signal(0);

  readonly isVisible = this._isVisible.asReadonly();
  readonly imageUrl = this._imageUrl.asReadonly();
  readonly altText = this._altText.asReadonly();
  readonly images = this._images.asReadonly();
  readonly currentIndex = this._currentIndex.asReadonly();

  open(data: LightboxData, images?: string[], startIndex: number = 0): void {
    this._imageUrl.set(data.imageUrl);
    this._altText.set(data.altText || '');
    this._images.set(images || []);
    this._currentIndex.set(startIndex);
    this._isVisible.set(true);
    document.body.style.overflow = 'hidden';
  }

  close(): void {
    this._isVisible.set(false);
    document.body.style.overflow = '';
    setTimeout(() => {
      this._imageUrl.set('');
      this._altText.set('');
      this._images.set([]);
      this._currentIndex.set(0);
    }, 300);
  }

  next(): void {
    const imgs = this._images();
    if (imgs.length === 0) return;

    const nextIndex = (this._currentIndex() + 1) % imgs.length;
    this._currentIndex.set(nextIndex);
    this._imageUrl.set(imgs[nextIndex]);
  }

  previous(): void {
    const imgs = this._images();
    if (imgs.length === 0) return;

    const prevIndex = this._currentIndex() === 0 ? imgs.length - 1 : this._currentIndex() - 1;
    this._currentIndex.set(prevIndex);
    this._imageUrl.set(imgs[prevIndex]);
  }
}
